module.exports = __webpack_public_path__ + "img/193.ac028c88.jpg";